let SOCKET_SERVER = process.env.WS_SERVER || "wss://socket.vecnoscan.org";
let SUFFIX = ""
let API_SERVER = process.env.REACT_APP_API_SERVER || "https://api.vecnoscan.org"
let ADDRESS_PREFIX = "vecno:"
let VECNO_UNIT = "VE"

let BPS = 1

export { SOCKET_SERVER, SUFFIX, API_SERVER, ADDRESS_PREFIX, BPS, VECNO_UNIT }